<template> 
    <paging :url="url" :params="queryParams" ref="paging" @loaded="onLoaded" :manually="manually">
        <el-table :data="grid.data" border style="width: 100%" slot-scope="grid" v-loading="grid.loading">
            <template v-if="columns.length > 0">
                <el-table-column align="center" :prop="col.prop" :label="col.label" :width="col.width" v-for="(col, index) in columns" :key="index"></el-table-column>
            </template>
            <slot name="grid" :data="grid.data">
            </slot>
        </el-table>
    </paging>
</template>

<script type="text/javascript">

import Paging from './Paging'

export default {
    components: {
        Paging
    },
    props: {
        manually: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Array,
            default: () => { return []; }
        },
        queryParams: {
            type: Object
        },
        url: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            activeName: 'first'
        }
    },
    methods: {
        onLoaded(val) {
            // 触发事件
            this.$emit('loaded',val);
        },
        reload(url){
            this.$refs['paging'].reload(url);
        },
        onSearch() {
            this.$refs['paging'].reload();
        },
        loadData() {
            this.$refs['paging'].loadData();
        },
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {}
}
</script>

<style type="text/css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Table/PagingTable.vue